export default "__VITE_ASSET__DN4jBv81__"